export default __webpack_public_path__ + "static/media/addPolicyImage.fdb5da9d.svg";